import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import './propertyWalkThroughForm.scss';
import {
  fetchPropertySuites,
  saveSuite,
  clearSuites,
} from '../../store/actions/suites';
import { fetchSuiteAssets, clearAssets } from '../../store/actions/assets';
import { fetchProperties } from '../../store/actions/properties';
import { fetchSuiteById } from '../../store/actions/suites';
import {
  selectProperties,
  selectPropertyById,
} from '../../store/selectors/properties';
import { selectSuites } from '../../store/selectors/suites';
import { selectServiceRequestFormData } from '../../store/selectors/serviceRequestForm';
import { selectSuiteById } from '../../store/selectors/suites';
import {
  setPropertyWalkThroughFormData,
  setPropertyWalkThroughFormPreviousStep,
  exitPropertyWalkThroughForm,
  setPropertyWalkThroughFormStep,
  setPropertyWalkThroughFormNextStep,
  getAreaAndSubAreaStatus,
} from '../../store/actions/propertyWalkThroughForm';
import Button from '../Button';
import Col from '../Col';
import Form from '../Form';
import Row from '../Row';
import Select from '../Select';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { selectPropertyWalkThroughFormData } from '../../store/selectors/propertyWalkThroughForm';
import Tile from '../Tile';
import FontAwesomeIcon from '../Icon';
import { ICONS } from '../../common/constants';
import Textarea from '../Textarea';
import File from '../File';
import Input from '../../components/Input';
import Enemies from '../Enemies';
import Table, { Hidden } from '../Table';
import Overlay from '../Overlay';
import AssetForm from '../AssetForm';
import moment from 'moment';
import {
  setAssetFormData,
  clearAssetFormData,
} from '../../store/actions/assetForm';
import PropertyWalkThroughForm from './PropertyWalkThroughForm';
import { fetchItems } from '../../store/actions/items';
import {
  saveAsset,
  updateAsset,
  deleteAsset,
} from '../../store/actions/assets';
import {
  fetchAreasAndSubAreas,
  saveAssetConfig,
  deleteSubArea,
  saveSubAreaDescription,
  fetchSubAreaData,
  fetchAreaData,
  saveAreaDescription,
  changeSequenceAreasAndSubAreasDone,
  changeSequenceAreaOrder,
} from '../../store/actions/areas';
import { selectAreas } from '../../store/selectors/areas';
import { upload } from '../../helpers/upLoadHelper';
import Loader from '../../components/Loader';
import {
  setEasyWalkThroughFormData,
  exitEasyWalkThroughForm,
} from '../../store/actions/easyWalkThroughForm';
import { setWalkThroughStatus } from '../../store/actions/suites';
import PropertyForm from '../PropertyForm';
import { propertyOf } from 'lodash';
import {
  fetchFaqsNotesDocuments,
  saveFaqsNotesDocuments,
  updateFaqsNotesDocuments,
  deleteFaqsNotesDocuments,
} from '../../store/actions/faqsNotesDocuments';
import classNames from 'classnames';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchSuiteWalkThroughs } from '../../store/actions/walkThroughs';
// import variables from '../../styles/includes/variables.scss';

import { variables } from '../../Tenants';

class ConfigureSubArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      sequence: {},
    };
  }
  componentWillMount() {
    const { user, getAreaAndSubAreaStatus, propertyWalkThroughFormData } =
      this.props;
  }
  componentDidMount() {
    const {
      onFetchItems,
      onFetchAreasAndSubAreas,
      areas,
      onFetchSubAreaData,
      onSetPropertyWalkThroughFormData,
      propertyWalkThroughFormData,
      onFetchAreaData,
    } = this.props;
    onFetchItems();
    if (areas.length > 0) {
      // if (areas[0].subAreas.length > 0) {
      if (!propertyWalkThroughFormData.selectedAreaId) {
        onSetPropertyWalkThroughFormData({
          selectedArea: areas[0].name,
          subAreaName: areas[0].customLabel
            ? areas[0].customLabel
            : areas[0].name,
          type: 'Area',
          selectedAreaId: areas[0].areaId,
          checkListValue: '',
        });
        onFetchAreaData(
          propertyWalkThroughFormData.walkthroughId,
          areas[0].areaId
        );
      } else {
        onSetPropertyWalkThroughFormData({
          selectedArea: areas[0].name,
          subAreaName: areas[0].customLabel
            ? areas[0].customLabel
            : areas[0].name,
          type: 'Area',
          selectedAreaId: areas[0].areaId,
          checkListValue: '',
        });
        onFetchAreaData(
          propertyWalkThroughFormData.walkthroughId,
          areas[0].areaId
        );
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      propertyWalkThroughFormData,
      areas,
      onFetchSubAreaData,
      onSetPropertyWalkThroughFormData,
      onFetchAreaData,
    } = this.props;
    if (prevProps.areas !== areas) {
      if (!propertyWalkThroughFormData.selectedAreaId) {
        onSetPropertyWalkThroughFormData({
          selectedArea: areas[0].name,
          subAreaName: areas[0].customLabel
            ? areas[0].customLabel
            : areas[0].name,
          type: 'Area',
          selectedAreaId: areas[0].areaId,
          checkListValue: '',
        });
        onFetchAreaData(
          propertyWalkThroughFormData.walkthroughId,
          areas[0].areaId
        );
      }
    }
  }

  onSaveAsset = (asset) => {
    const { propertyWalkThroughFormData, user, onSaveSuite } = this.props;
    const {
      suiteName,
      suiteId,
      propertyId,
      homeownerId,
      selectedArea,
      subAreaDescription,
      configTypeSaved,
      selectedAreaId,
    } = propertyWalkThroughFormData;

    let params = {
      UnitId: suiteId,
      ItemId: asset.itemId,
      RoomType: asset.roomType,
      UserId: this.props.user.id,
      Name: asset.item.name,
      Description: '',
      WalkthroughId: configTypeSaved.id,
      AreaId: asset.areaId,
      DateOfPurchase: asset.dateOfPurchase
        ? new Date(moment(asset.dateOfPurchase).format('l LT'))
        : null,
      VendorId: asset && asset.vendorId ? asset.vendorId : null,
      VendorName: asset && asset.vendorId ? asset.vendorName : '',
    };
    if (!asset.vendorId) {
      delete params.VendorId;
      delete params.VendorName;
    }

    this.props.onSaveAsset(params, propertyWalkThroughFormData.walkthroughId);
  };

  onSaveSubArea = async () => {
    const {
      propertyWalkThroughFormData,
      user,
      onSaveSubAreaDescription,
      onSetPropertyWalkThroughFormData,
      onSaveAreaDescription,
      getAreaAndSubAreaStatus,
    } = this.props;

    let {
      suiteId,
      subAreaName,
      subAreaDescription,
      configTypeSaved,
      selectedAreaId,
      walkThroughMedia,
      deletedFiles,
      checkList,
      question,
      answer,
      item,
      checkListValue,
    } = propertyWalkThroughFormData;

    if (propertyWalkThroughFormData.edited === true) {
      onSetPropertyWalkThroughFormData({ edited: false });
      let imageUrl = null;
      let name = '';

      if (checkListValue !== '') {
        if (checkList && checkList.length > 0) {
          checkList = [
            ...checkList,
            { description: propertyWalkThroughFormData.checkListValue },
          ];
        } else {
          checkList = [
            {
              description: propertyWalkThroughFormData.checkListValue,
            },
          ];
        }
      }
      onSetPropertyWalkThroughFormData({ checkListValue: '' });

      if (
        propertyWalkThroughFormData.deletedCheckList &&
        propertyWalkThroughFormData.deletedCheckList.length > 0
      ) {
        checkList = [
          ...checkList,
          ...propertyWalkThroughFormData.deletedCheckList,
        ];
      }
      onSetPropertyWalkThroughFormData({ checkList });

      onSetPropertyWalkThroughFormData({ edited: false });

      let faqs =
        propertyWalkThroughFormData.walkthroughFAQDetails &&
        propertyWalkThroughFormData.walkthroughFAQDetails.length > 0
          ? propertyWalkThroughFormData.walkthroughFAQDetails.map((f) => {
              if (f.id) {
                if (f.isDeleted === true) {
                  return {
                    id: f.id,
                    questionId: f.questionId,
                    isDeleted: true,
                  };
                } else {
                  if (f.id && f.questionId) {
                    return { id: f.id, questionId: f.questionId };
                  }
                  return { questionId: f.id };
                }
              }
            })
          : [];

      let params = {
        id: propertyWalkThroughFormData.subAreaId,
        UnitId: suiteId,
        Name: subAreaName,
        Description: subAreaDescription,
        walkthroughId: propertyWalkThroughFormData.walkthroughId,
        AreaId: selectedAreaId,
        userId: user.id,
        walkThroughMedia: [],
        WalkthroughChecklistItems: checkList,
        WalkthroughFAQDetails: faqs,
      };

      if (propertyWalkThroughFormData.type !== 'Area') {
        params.assetId = propertyWalkThroughFormData.assetId;
      }
      if (walkThroughMedia && walkThroughMedia.length > 0) {
        await this.handleMultipleUpload(walkThroughMedia, function (resObj) {
          let files =
            propertyWalkThroughFormData.deletedFiles &&
            propertyWalkThroughFormData.deletedFiles.length > 0
              ? [...resObj, ...propertyWalkThroughFormData.deletedFiles]
              : resObj;

          params.walkThroughMedia = files;
          if (propertyWalkThroughFormData.type === 'Area') {
            onSaveAreaDescription(
              params,
              propertyWalkThroughFormData.walkthroughId
            );
          } else {
            onSaveSubAreaDescription(
              params,
              propertyWalkThroughFormData.walkthroughId
            );
          }
        });
      } else {
        if (deletedFiles && deletedFiles.length > 0) {
          params.walkThroughMedia = deletedFiles;
        }
        if (propertyWalkThroughFormData.type === 'Area') {
          onSaveAreaDescription(
            params,
            propertyWalkThroughFormData.walkthroughId
          );
        } else {
          onSaveSubAreaDescription(
            params,
            propertyWalkThroughFormData.walkthroughId
          );
        }
      }
    } 
  };

  handleMultipleUpload = async (subAreaMedia, callback) => {
    let uploadImages = [];
    for (let i = 0; i < subAreaMedia.length; i++) {
      if (subAreaMedia[i] && subAreaMedia[i].id) {
        uploadImages.push(subAreaMedia[i]);
      } else {
        await this.uploadimg(subAreaMedia[i], (imgData) => {
          uploadImages.push(imgData);
        });
      }
    }
    callback(uploadImages);
  };
  uploadimg = async (imgFile, callback) => {
    let imageUrl = await upload(imgFile);
    let object = {
      Name: imageUrl.split('.com/')[1],
      URL: imageUrl,
    };
    callback(object);
  };

  handleCall() {
    const {
      propertyWalkThroughFormData,
      onSetPropertyWalkThroughFormNextStep,
      onFetchAreaData,
      onSetPropertyWalkThroughFormData,
      user,
    } = this.props;
    const { suiteId, propertyId, selectedAreaId, walkthroughId } =
      propertyWalkThroughFormData;

    onSetPropertyWalkThroughFormNextStep();
    if (
      propertyWalkThroughFormData.status === 'Configure' ||
      propertyWalkThroughFormData.status === 'In Progress'
    ) {
      let params = {
        WalkthroughId: propertyWalkThroughFormData.walkthroughId,
        SuiteId: propertyWalkThroughFormData.suiteId,
        UserId: user.id,
        Role: user.roles[0].role.name,
        Signature: '',
        status: 'Activate',
      };
      if (
        propertyWalkThroughFormData.walkthroughType === 'Enhanced' &&
        propertyWalkThroughFormData.permissions === 'Internal'
      ) {
        params.status = 'Begin';
      }
      this.props.setWalkThroughStatus(params);
    }

    onSetPropertyWalkThroughFormData({
      description: '',
      question: '',
      subAreaDescription: '',
      walkThroughMedia: [],
      checkList: [],
    });

    onFetchAreaData(walkthroughId, selectedAreaId);
  }

  handleNext() {
    const {
      propertyWalkThroughFormData,
      onSetPropertyWalkThroughFormNextStep,
      onFetchAreaData,
      onSetPropertyWalkThroughFormData,
      user,
    } = this.props;
    const { suiteId, propertyId, selectedAreaId, walkthroughId } =
      propertyWalkThroughFormData;
    if (
      propertyWalkThroughFormData.edited &&
      propertyWalkThroughFormData.edited === true
    ) {
      alert(
        'Please Click Save Area/Sub area Button at bottom to save the changes made to area/sub area '
      );
    } else {
      onSetPropertyWalkThroughFormData({ edited: false });
      // TODO: Check this, the original seems to always be false, but worth looking into
      // if (propertyWalkThroughFormData.areaAndSubAreaStatus === false) {
      //   window.confirm(
      //     "We've noticed not all areas and/or sub-areas are saved. Are you sure you want to complete the walk-through?"
      //   ) && this.handleCall();
      // }
      // else {
        let params = {
          WalkthroughId: propertyWalkThroughFormData.walkthroughId,
          SuiteId: propertyWalkThroughFormData.suiteId,
          UserId: user.id,
          Role: user.roles[0].role.name,
          Signature: '',
          status: 'Activate',
        };
        if (
          propertyWalkThroughFormData.walkthroughType === 'Enhanced' &&
          propertyWalkThroughFormData.permissions === 'Internal'
        ) {
          params.status = 'Begin';
        }
        this.props.setWalkThroughStatus(params);
        onFetchAreaData(walkthroughId, selectedAreaId);

        onSetPropertyWalkThroughFormData({
          description: '',
          question: '',
          subAreaDescription: '',
          walkThroughMedia: [],
          checkList: [],
        });

        onSetPropertyWalkThroughFormNextStep();
      // }
    }
  }

  inputFeilds() {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } =
      this.props;
    return (
      <Row mdCenter>
        <Col granola xs="12" md="8">
          <Textarea
            label="Description"
            placeholder={
              'Provide orientation details about this ' + variables.suite + '.'
            }
            onChange={(e) =>
              onSetPropertyWalkThroughFormData({ description: e.target.value })
            }
            value={propertyWalkThroughFormData.description}
            block
          />

          <File
            label="Media"
            onSelect={(file) =>
              onSetPropertyWalkThroughFormData({ selectedImage: file })
            }
            files={
              propertyWalkThroughFormData.selectedImage
                ? propertyWalkThroughFormData.selectedImage
                : []
            }
            // image={fndForm.image}
            // errors={''}
          />
        </Col>
      </Row>
    );
  }

  handleAddCheckList() {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } =
      this.props;
    let checkList = propertyWalkThroughFormData.checkList
      ? propertyWalkThroughFormData.checkList
      : [];
    if (propertyWalkThroughFormData.checkListValue.trim().length > 0) {
      checkList = [
        ...checkList,
        { description: propertyWalkThroughFormData.checkListValue },
      ];
      onSetPropertyWalkThroughFormData({
        checkList: checkList,
        checkListValue: '',
        edited: true,
      });
    } else {
      onSetPropertyWalkThroughFormData({ checkListValue: '' });
    }
  }

  handleDeleteCheckList(item, i) {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } =
      this.props;

    let deletedCheckList =
      propertyWalkThroughFormData.deletedCheckList &&
      propertyWalkThroughFormData.deletedCheckList.length > 0
        ? propertyWalkThroughFormData.deletedCheckList
        : [];
    if (item.id) {
      item = { ...item, isDeleted: true };
      deletedCheckList = [item, ...deletedCheckList];
    }
    let checkList = propertyWalkThroughFormData.checkList;
    if (item.id) {
      checkList = checkList.filter((i) => i.id !== item.id);
    } else {
      checkList = checkList.filter((data, index) => index !== i);
    }

    // let checkList = propertyWalkThroughFormData.checkList.filter(i =>  item.id ? item.id === i.id : i.description !== item.description)
    onSetPropertyWalkThroughFormData({
      checkList,
      deletedCheckList,
      edited: true,
    });
  }

  //   selectMultipleItems = (files) => {

  //     const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } = this.props;
  //     let filteredFiles = files.filter(file => propertyWalkThroughFormData.walkThroughMedia ? !propertyWalkThroughFormData.walkThroughMedia.includes(file) : propertyWalkThroughFormData.walkThroughMedia ? propertyWalkThroughFormData.walkThroughMedia : [])

  //     onSetPropertyWalkThroughFormData({ walkThroughMedia: filteredFiles })

  //     // let data = [...propertyWalkThroughFormData.selectedImage, files]

  //   }

  selectMultipleItems = (files) => {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } =
      this.props;
    if (
      propertyWalkThroughFormData.walkThroughMedia &&
      propertyWalkThroughFormData.walkThroughMedia.length
    ) {
      let walkThroughMedia = propertyWalkThroughFormData.walkThroughMedia;
      for (var i = 0; i < walkThroughMedia.length; i++) {
        if (walkThroughMedia[i].id) {
        } else {
          for (var j = 0; j < files.length; j++) {
            if (files[j].name === walkThroughMedia[i].name) {
              files.splice(j, 1);
            }
          }
        }
      }

      onSetPropertyWalkThroughFormData({
        walkThroughMedia: [...files, ...walkThroughMedia],
      });
      // files.filter(file => {
      //   if(propertyWalkThroughFormData.walkThroughMedia.includes(file)) {
      //   } else {
      //   let obj = [
      //     file, ...propertyWalkThroughFormData.walkThroughMedia
      //   ]
      //   return (
      //     onSetPropertyWalkThroughFormData({ walkThroughMedia: obj,edited:true})
      //   )
      //   }
      // })
    } else {
      onSetPropertyWalkThroughFormData({
        walkThroughMedia: files,
        edited: true,
      });
    }
  };

  handleDelete(item, i) {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } =
      this.props;
    let walkThroughMedia = propertyWalkThroughFormData.walkThroughMedia;
    let deletedFiles = propertyWalkThroughFormData.deletedFiles
      ? propertyWalkThroughFormData.deletedFiles
      : [];

    if (item.id) {
      item = { ...item, isDeleted: true };
      deletedFiles = [item, ...deletedFiles];
    }
    walkThroughMedia = propertyWalkThroughFormData.walkThroughMedia.filter(
      (data) => (data && data.id ? data.id !== item.id : data !== item)
    );
    onSetPropertyWalkThroughFormData({
      walkThroughMedia,
      deletedFiles,
      edited: true,
    });
  }

  handleEditCheckList(e, item, i) {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } =
      this.props;
    let checkList = propertyWalkThroughFormData.checkList;
    checkList = checkList.map((data, j) => {
      if (i === j) {
        item = { ...item, description: e.target.value };
        return item;
      } else {
        return data;
      }
    });
    onSetPropertyWalkThroughFormData({ checkList, edited: true });
  }

  faqs() {
    const { propertyWalkThroughFormData } = this.props;
    let search =
      propertyWalkThroughFormData.search &&
      propertyWalkThroughFormData.search.trim().length > 0
        ? propertyWalkThroughFormData.search.toLowerCase()
        : null;
    let questions =
      propertyWalkThroughFormData.questions &&
      propertyWalkThroughFormData.questions.length > 0
        ? propertyWalkThroughFormData.questions
        : [];
    let filtered = [];
    if (questions.length > 0) {
      for (var i = 0; i < questions.length; i++) {
        let indexOf = questions[i].question.toLowerCase().indexOf(search);
        if (indexOf >= 0) {
          filtered.push(questions[i]);
        }
      }
      let index = filtered.length + 1;
      filtered.splice(index, 0, { question: 'Add one' });
      return filtered;
    } else {
      return [{ question: 'Add one' }];
    }
  }

  addFaq(faq, type) {
    const { propertyWalkThroughFormData, onSetPropertyWalkThroughFormData } =
      this.props;
    let FAQDetails =
      propertyWalkThroughFormData.walkthroughFAQDetails.length > 0
        ? propertyWalkThroughFormData.walkthroughFAQDetails
        : [];
    if (FAQDetails.length > 0) {
      let includes = FAQDetails.filter((f) => f.id === faq.id);
      if (includes.length > 0) {
        if (type !== 'add') {
          if (includes[0].isDeleted === false) {
            let j = includes[0];
            j = { ...j, isDeleted: true };

            FAQDetails = FAQDetails.map((f) => {
              if (f.id === faq.id) {
                return j;
              } else {
                return f;
              }
            });
          } else {
            FAQDetails = FAQDetails.filter((f) => f.id !== faq.id);
          }
        }
      } else if (includes.length === 0) {
        FAQDetails = [...FAQDetails, faq];
      }
    } else {
      FAQDetails.push(faq);
    }

    onSetPropertyWalkThroughFormData({
      walkthroughFAQDetails: FAQDetails,
      search: '',
      edited: true,
    });
  }

  saveFaq() {
    const {
      propertyWalkThroughFormData,
      onSetPropertyWalkThroughFormData,
      onSaveFaqsNotesDocuments,
    } = this.props;
    let data = {
      question: propertyWalkThroughFormData.search,
      answer: propertyWalkThroughFormData.answer,
      type: 'General',
      issue: 'category',
      linkTitle: 'link title',
      caption: 'caption',
      image: '',
    };

    let params = {
      // 'question':data.question,
      ItemId: propertyWalkThroughFormData.itemId
        ? propertyWalkThroughFormData.itemId
        : '',
      Name: 'Frequently Asked Questions',
      Type: 'FAQS',
      data: JSON.stringify(data).toString(),
    };
    // let FAQDetails = propertyWalkThroughFormData.walkthroughFAQDetails;
    // FAQDetails = [ ...FAQDetails,...[params]]

    onSaveFaqsNotesDocuments(
      params,
      'addInFaqWalkThrough',
      propertyWalkThroughFormData
    );
    onSetPropertyWalkThroughFormData({
      enableFaqAnswer: false,
      search: '',
      answer: '',
      // walkthroughFAQDetails:FAQDetails
    });
  }

  onDropSequence = (areaData, i) => {
    const {
      onChangeSequenceAreasAndSubAreasDone,
      onChangeSequenceAreaOrder,
      propertyWalkThroughFormData,
    } = this.props;
    let data = {
      SequenceList: [
        {
          id: this.state.sequence.id,
          Sequence: areaData.sequence,
          UserId: this.state.sequence.userId,
        },
        {
          id: areaData.id,
          Sequence: this.state.sequence.sequence,
          UserId: areaData.userId,
        },
      ],
    };
    let sequenceData = this.state.sequence;
    //  onChangeSequenceAreasAndSubAreasDone({...sequenceData, sequence: areaData.sequence}, {...areaData, sequence: sequenceData.sequence});
    onChangeSequenceAreaOrder(data, propertyWalkThroughFormData.walkthroughId);
    this.setState({ sequence: {} });
  };

  render() {
    const {
      propertyWalkThroughFormData,
      onSetPropertyWalkThroughFormStep,
      onFetchPropertySuites,
      onExitEasyWalkThroughForm,
      onSetPropertyWalkThroughFormNextStep,
      onSetPropertyWalkThroughFormData,
      onSetPropertyWalkThroughFormPreviousStep,
      onExitPropertyWalkThroughForm,
      onClose,
      user,
      suite,
      clearAssetFormData,
      areas,
      onDeleteSubArea,
      onFetchSubAreaData,
      loader,
      onFetchAreaData,
      onSetEasyWalkThroughFormData,
      setAssetFormData,
      fetchSuiteWalkThroughs,
    } = this.props;
    const { propertyName, suiteName, walkthroughId } =
      propertyWalkThroughFormData;
    const { showOverlay } = this.state;
    let faqs = this.faqs();
    const roleName = user.roles[0].role.name;
    return (
      <>
        {loader === true ? <Loader center={true} /> : null}
        <div class="header_section">
          <div class="header_box">
            <div class="header_back_btn">
              <div
                class="back_arrow"
                onClick={() => {
                  fetchSuiteWalkThroughs(
                    propertyWalkThroughFormData.suiteId,
                    roleName
                  );
                  onExitPropertyWalkThroughForm();
                  onExitEasyWalkThroughForm();
                }}
              >
                <a href="#.">
                  <svg
                    width="21"
                    height="18"
                    viewBox="0 0 21 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 7.71429V10.2857H5.25L10.5 15.4286L9.1875 18L0 9L9.1875 0L10.5 2.57143L5.25 7.71429H21Z"
                      fill="#1D1D1D"
                    />
                  </svg>
                </a>
              </div>
            </div>
            <div class="configure_heading">
              <h2>Configure Walk Through</h2>
            </div>
            <div class="next_btn text-right" onClick={() => this.handleNext()}>
              <a
                href="#."
                style={{
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid whitesmoke',
                  borderRadius: '5px',
                }}
              >
                Save Walk Through
              </a>
            </div>
          </div>
        </div>
        <div
          class="avenue_section bedroom_list_section WalkthroughScroll"
          style={{ width: '92%' }}
        >
          <div class="avenue_main_box">
            <div class="avenue_heading">
              <h4>{propertyName + ', ' + suiteName}</h4>
            </div>
            <div class="bedroom_list_box">
              <div class="bedroom_main_section">
                <div class="bedroom_section">
                  {areas.map((area, i) => (
                    <div
                      class="bedroom_main_box"
                      class={
                        propertyWalkThroughFormData.selectedArea === area.name
                          ? 'bedroom_main_box1 order_active'
                          : 'bedroom_main_box1 order_inactive'
                      }
                      onClick={() => {
                        onSetEasyWalkThroughFormData({ areaId: area.areaId });
                        onSetPropertyWalkThroughFormData({
                          selectedArea: area.name,
                          subAreaId: area.id,
                          type: 'Area',
                          selectedAreaId: area.areaId,
                          subAreaName: area.customLabel
                            ? area.customLabel
                            : area.name,
                          checkListValue: '',
                          question: '',
                          answer: '',
                          showSubArea: false,
                          deletedCheckList: [],
                          edited: false,
                        });
                        onFetchAreaData(walkthroughId, area.areaId);
                      }}
                    >
                      <div
                        class={
                          propertyWalkThroughFormData.selectedArea === area.name
                            ? 'bedroom_heading active text_elipse'
                            : 'bedroom_heading text_elipse'
                        }
                        // class={propertyWalkThroughFormData.subAreaName === area.customLabel ? area.customLabel : area.name ? "bedroom_heading active" : "bedroom_heading"}
                        style={{
                          cursor: 'pointer',
                          padding: 10,
                          width: 'auto',
                        }}
                        draggable
                        onDragStart={() => {
                          this.setState({
                            sequence: { ...area, order: area.sequence },
                          });
                        }}
                        onDrop={() => {
                          this.onDropSequence(area, i);
                        }}
                        onDragOver={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                        }}
                      >
                        <div class="bed_icon">
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17.1001 5.53747C16.9243 5.71303 16.686 5.81164 16.4376 5.81164C16.1891 5.81164 15.9508 5.71303 15.7751 5.53747L13.9376 3.69997V8.31247C13.9376 8.56111 13.8388 8.79957 13.663 8.97538C13.4872 9.1512 13.2487 9.24997 13.0001 9.24997C12.7514 9.24997 12.513 9.1512 12.3371 8.97538C12.1613 8.79957 12.0626 8.56111 12.0626 8.31247V3.69997L10.2251 5.53747C10.0473 5.70307 9.81228 5.79322 9.5694 5.78894C9.32652 5.78465 9.09479 5.68626 8.92303 5.5145C8.75126 5.34273 8.65287 5.111 8.64858 4.86812C8.6443 4.62525 8.73445 4.39019 8.90005 4.21247L12.3376 0.774969C12.5133 0.599405 12.7516 0.500793 13.0001 0.500793C13.2485 0.500793 13.4868 0.599405 13.6626 0.774969L17.1001 4.21247C17.2756 4.38825 17.3742 4.62653 17.3742 4.87497C17.3742 5.12341 17.2756 5.36169 17.1001 5.53747Z"
                              fill="#8E8E8E"
                            />
                            <path
                              d="M5.53741 15.775C5.62952 15.8608 5.70339 15.9643 5.75463 16.0793C5.80587 16.1943 5.83343 16.3185 5.83565 16.4443C5.83787 16.5702 5.81471 16.6953 5.76756 16.812C5.72041 16.9287 5.65023 17.0348 5.56121 17.1238C5.47218 17.2128 5.36614 17.283 5.2494 17.3301C5.13267 17.3773 5.00763 17.4004 4.88175 17.3982C4.75588 17.396 4.63173 17.3685 4.51674 17.3172C4.40174 17.266 4.29823 17.1921 4.21241 17.1L0.774908 13.6625C0.599344 13.4867 0.500732 13.2484 0.500732 13C0.500732 12.7516 0.599344 12.5133 0.774908 12.3375L4.21241 8.89999C4.39013 8.73439 4.62518 8.64424 4.86806 8.64852C5.11094 8.65281 5.34267 8.7512 5.51443 8.92296C5.6862 9.09473 5.78459 9.32646 5.78888 9.56934C5.79316 9.81222 5.70301 10.0473 5.53741 10.225L3.69991 12.0625H8.31241C8.56105 12.0625 8.7995 12.1613 8.97532 12.3371C9.15114 12.5129 9.24991 12.7513 9.24991 13C9.24991 13.2486 9.15114 13.4871 8.97532 13.6629C8.7995 13.8387 8.56105 13.9375 8.31241 13.9375H3.69991L5.53741 15.775Z"
                              fill="#8E8E8E"
                            />
                            <path
                              d="M20.4625 17.1C20.2869 16.9242 20.1883 16.6859 20.1883 16.4375C20.1883 16.1891 20.2869 15.9508 20.4625 15.775L22.3 13.9375H17.6875C17.4389 13.9375 17.2004 13.8387 17.0246 13.6629C16.8488 13.4871 16.75 13.2486 16.75 13C16.75 12.7514 16.8488 12.5129 17.0246 12.3371C17.2004 12.1613 17.4389 12.0625 17.6875 12.0625H22.3L20.4625 10.225C20.2969 10.0473 20.2067 9.81222 20.211 9.56934C20.2153 9.32646 20.3137 9.09473 20.4855 8.92296C20.6572 8.7512 20.889 8.65281 21.1318 8.64852C21.3747 8.64424 21.6098 8.73439 21.7875 8.89999L25.225 12.3375C25.4006 12.5133 25.4992 12.7516 25.4992 13C25.4992 13.2484 25.4006 13.4867 25.225 13.6625L21.7875 17.1C21.6117 17.2756 21.3734 17.3742 21.125 17.3742C20.8766 17.3742 20.6383 17.2756 20.4625 17.1Z"
                              fill="#8E8E8E"
                            />
                            <path
                              d="M17.1001 20.4625C16.9243 20.2869 16.686 20.1883 16.4376 20.1883C16.1891 20.1883 15.9508 20.2869 15.7751 20.4625L13.9376 22.3V17.6875C13.9376 17.4389 13.8388 17.2004 13.663 17.0246C13.4872 16.8488 13.2487 16.75 13.0001 16.75C12.7514 16.75 12.513 16.8488 12.3371 17.0246C12.1613 17.2004 12.0626 17.4389 12.0626 17.6875V22.3L10.2251 20.4625C10.0473 20.2969 9.81228 20.2067 9.5694 20.211C9.32652 20.2153 9.09479 20.3137 8.92303 20.4855C8.75126 20.6572 8.65287 20.889 8.64858 21.1318C8.6443 21.3747 8.73445 21.6098 8.90005 21.7875L12.3376 25.225C12.5133 25.4006 12.7516 25.4992 13.0001 25.4992C13.2485 25.4992 13.4868 25.4006 13.6626 25.225L17.1001 21.7875C17.2756 21.6117 17.3742 21.3734 17.3742 21.125C17.3742 20.8766 17.2756 20.6383 17.1001 20.4625Z"
                              fill="#8E8E8E"
                            />
                          </svg>
                        </div>
                        <h3
                          className="title_elipse"
                          style={{
                            color:
                              propertyWalkThroughFormData.selectedArea ===
                                area.name && '#fff',
                          }}
                        >
                          {area.customLabel ? area.customLabel : area.name}
                        </h3>
                      </div>
                    </div>
                  ))}
                </div>
                <div class="bedroom_right_section">
                  <div class="bedroom_list_item_box">
                    <div class="area_heading">
                      <h4>Area :</h4>
                      <label for="" style={{ padding: '0px' }}>
                        {propertyWalkThroughFormData.subAreaName}
                      </label>
                    </div>
                  </div>
                  <div class="bedroom_list_item_box">
                    <div class="area_heading">
                      <h4>Check List :</h4>
                      {propertyWalkThroughFormData.checkList &&
                      propertyWalkThroughFormData.checkList.length > 0
                        ? propertyWalkThroughFormData.checkList.map(
                            (item, i) =>
                              item.isDeleted !== true ? (
                                <div class="mainDiv">
                                  <div class="w-93">
                                    <input
                                      class="form-control"
                                      type="text"
                                      value={item.description}
                                      onChange={(e) =>
                                        this.handleEditCheckList(e, item, i)
                                      }
                                      aria-label="default input example"
                                    ></input>
                                  </div>
                                  <div class="w-7">
                                    <a
                                      class="closeBtn"
                                      style={{ cursor: 'pointer' }}
                                      onClick={() =>
                                        this.handleDeleteCheckList(item, i)
                                      }
                                    >
                                      <svg
                                        width="10"
                                        height="10"
                                        viewBox="0 0 10 10"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M0.258279 0.580619C0.404791 0.434106 0.603506 0.351796 0.810706 0.351796C1.01791 0.351796 1.21662 0.434106 1.36313 0.580619L4.67769 3.89518L7.99225 0.580619C8.13876 0.434106 8.33748 0.351796 8.54468 0.351796C8.75188 0.351796 8.95059 0.434106 9.0971 0.580619C9.24361 0.727132 9.32592 0.925845 9.32593 1.13305C9.32593 1.34025 9.24361 1.53896 9.0971 1.68547L5.78254 5.00003L9.0971 8.31459C9.24361 8.4611 9.32593 8.65982 9.32593 8.86702C9.32592 9.07422 9.24361 9.27293 9.0971 9.41944C8.95059 9.56595 8.75188 9.64826 8.54468 9.64827C8.33748 9.64826 8.13876 9.56595 7.99225 9.41944L4.67769 6.10488L1.36313 9.41944C1.21662 9.56595 1.01791 9.64827 0.810706 9.64826C0.603506 9.64826 0.404791 9.56595 0.258279 9.41944C0.111766 9.27293 0.0294564 9.07422 0.0294564 8.86702C0.0294565 8.65982 0.111766 8.4611 0.258279 8.31459L3.57284 5.00003L0.258279 1.68547C0.111766 1.53896 0.0294565 1.34025 0.0294564 1.13305C0.0294564 0.925845 0.111766 0.727132 0.258279 0.580619Z"
                                          fill="black"
                                        ></path>
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                              ) : null
                          )
                        : null}
                      <div class="mainDiv">
                        <div class="">
                          <input
                            class="form-control"
                            type="text"
                            placeholder="Enter Checklist"
                            value={propertyWalkThroughFormData.checkListValue}
                            onChange={(e) =>
                              onSetPropertyWalkThroughFormData({
                                checkListValue: e.target.value,
                                edited: true,
                              })
                            }
                            aria-label="default input example"
                          ></input>
                        </div>

                        <div class="">
                          <button
                            className="btnchecklist"
                            onClick={() => this.handleAddCheckList()}
                          >
                            + Add New Row
                          </button>
                          {/* <a href="#."  class="closeBtn" onClick={() => this.handleAddCheckList()}>
                                      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.24999 0C6.45719 0 6.65591 0.0823101 6.80242 0.228823C6.94893 0.375335 7.03124 0.574049 7.03124 0.781249V5.46874L11.7187 5.46874C11.9259 5.46874 12.1246 5.55105 12.2712 5.69757C12.4177 5.84408 12.5 6.04279 12.5 6.24999C12.5 6.45719 12.4177 6.65591 12.2712 6.80242C12.1246 6.94893 11.9259 7.03124 11.7187 7.03124L7.03124 7.03124L7.03124 11.7187C7.03124 11.9259 6.94893 12.1246 6.80242 12.2712C6.65591 12.4177 6.45719 12.5 6.24999 12.5C6.04279 12.5 5.84408 12.4177 5.69757 12.2712C5.55105 12.1246 5.46874 11.9259 5.46874 11.7187L5.46874 7.03124H0.781249C0.574049 7.03124 0.375335 6.94893 0.228823 6.80242C0.0823101 6.65591 0 6.45719 0 6.24999C0 6.04279 0.0823101 5.84408 0.228823 5.69757C0.375335 5.55105 0.574049 5.46874 0.781249 5.46874H5.46874V0.781249C5.46874 0.574049 5.55105 0.375335 5.69757 0.228823C5.84408 0.0823101 6.04279 0 6.24999 0Z" fill="#1D1D1D"></path>
                            </svg> 
                            </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="next_btn text-right"
                    onClick={() => this.onSaveSubArea()}
                  >
                    <a href="#">Save</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Overlay
          showOverlay={showOverlay}
          content={
            <AssetForm
              selectedAreaId={propertyWalkThroughFormData.selectedAreaId}
              newAsset={true}
              suiteId={propertyWalkThroughFormData.suiteId}
              onClose={() => {
                this.setState({ showOverlay: false }, () =>
                  clearAssetFormData()
                );
              }}
              onSaveAsset={(data) => this.onSaveAsset(data)}
            />
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let propertyWalkThroughFormData = selectPropertyWalkThroughFormData(state);
  let suite = selectSuiteById(state, propertyWalkThroughFormData.suiteId);
  return {
    suite,
    propertyWalkThroughFormData,
    user: selectAuthenticatedUser(state),
    areas: state.areas,
    loader: selectFormLoader(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onSetPropertyWalkThroughFormData: setPropertyWalkThroughFormData,
      onSetPropertyWalkThroughFormPreviousStep:
        setPropertyWalkThroughFormPreviousStep,
      onSetPropertyWalkThroughFormNextStep: setPropertyWalkThroughFormNextStep,
      onExitPropertyWalkThroughForm: exitPropertyWalkThroughForm,
      setAssetFormData: setAssetFormData,
      clearAssetFormData,
      onSaveAsset: saveAssetConfig,
      onFetchItems: fetchItems,
      onFetchAreasAndSubAreas: fetchAreasAndSubAreas,
      onDeleteSubArea: deleteSubArea,
      onSaveSubAreaDescription: saveSubAreaDescription,
      onFetchSubAreaData: fetchSubAreaData,
      onFetchAreaData: fetchAreaData,
      onSaveAreaDescription: saveAreaDescription,
      onSetEasyWalkThroughFormData: setEasyWalkThroughFormData,
      setWalkThroughStatus: setWalkThroughStatus,
      onSetPropertyWalkThroughFormStep: setPropertyWalkThroughFormStep,
      getAreaAndSubAreaStatus,
      onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
      onFetchPropertySuites: fetchPropertySuites,
      onExitEasyWalkThroughForm: exitEasyWalkThroughForm,
      onChangeSequenceAreasAndSubAreasDone: changeSequenceAreasAndSubAreasDone,
      onChangeSequenceAreaOrder: changeSequenceAreaOrder,
      fetchSuiteWalkThroughs,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ConfigureSubArea);
